import {
  AdminStatementManagement,
  UserStatementManagement,
} from 'pages/statements/components';

import { TokenExpired } from 'components/tokenExpired';
import { Unauthorized } from 'components/unauthorized';
import { useCanAccess } from 'hooks/useCanAccess';
import { useTutorialStore } from 'store/tutorialStore';
import { TutorialStatementManagement } from 'pages/statements/components/TutorialStatementManagement';

export const StatementManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('statements');
  const { isTutorialActive } = useTutorialStore();

  const determineComponent = () => {
    if (isExpired) {
      return <TokenExpired />;
    } else if (isTutorialActive) {
      return <TutorialStatementManagement />;
    } else if (isAdmin) {
      return <AdminStatementManagement />;
    } else if (canAccess) {
      return <UserStatementManagement />;
    } else {
      return <Unauthorized />;
    }
  };
  return determineComponent();
};
